import config from "@ers/config";
import * as Sentry from "@sentry/browser";
import React from "react";
import ReactDOM from "react-dom";
// extenders
import "@ers/extenders/object";
import "@ers/extenders/string";
import "@ers/extenders/array";
import "@ers/extenders/date";

import "./assets/styles/style.less";
import App from "./App";
import { beforeSendSentry } from "@ers/errors/";

if (config.sentry) {
	const cfg = { ...config.sentry, beforeSend: beforeSendSentry };
	Sentry.init(cfg);
}
ReactDOM.render(<App />, document.getElementById("root"));
